import TEALIUM from "../../enums/tealium-enums";
import { track } from "../../util/tealium";

/**
 * Tracks the Who's Close page view on load.
 * page_category: action_report, page_detail: list_view_{YYYYMM}, page_section: whos_close
 */
export const whosClosePageViewTrack = (period: string) => {
  track(
    TEALIUM.U_TAG_METHOD.VIEW,
    "",
    TEALIUM.CATEGORY.WHOS_CLOSE_AR,
    TEALIUM.CATEGORY.ACTION_REPORT,
    `list_view_${period}`,
    "",
  );
};

/**
 * Tracks click on the customize KPI button (filter icon).
 * click_action: customize_KPI, click_category: action_report, click_detail: whos_close
 */
export const whosCloseCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.WHOS_CLOSE_AR,
    "customize_KPI",
  );
};

/**
 * Tracks cancel action in the KPI selector modal.
 * click_action: cancel_customize_KPI, click_category: action_report, click_detail: whos_close
 */
export const whosCloseCancelCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.WHOS_CLOSE_AR,
    "cancel_customize_KPI",
  );
};

/**
 * Tracks apply action in the KPI selector modal.
 * click_action: apply_customize_KPI, click_category: action_report, click_detail: whos_close
 */
export const whosCloseApplyCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.WHOS_CLOSE_AR,
    "apply_customize_KPI",
  );
};

/**
 * Tracks sort ascending click.
 * click_action: sort_ascending, click_category: action_report, click_detail: whos_close
 */
export const whosCloseSortAscendingTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.WHOS_CLOSE_AR,
    "sort_ascending",
  );
};

/**
 * Tracks sort descending click.
 * click_action: sort_descending, click_category: action_report, click_detail: whos_close
 */
export const whosCloseSortDescendingTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.WHOS_CLOSE_AR,
    "sort_descending",
  );
};

/**
 * Tracks export button click.
 * click_action: export, click_category: action_report, click_detail: whos_close
 */
export const whosCloseExportTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.WHOS_CLOSE_AR,
    "export",
  );
};

/**
 * Tracks ABO profile click.
 * click_action: profile, click_category: action_report, click_detail: whos_close
 */
export const whosCloseProfileTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.WHOS_CLOSE_AR,
    "profile",
  );
};

/**
 * Tracks adding an ABO to the watchlist.
 * click_action: add_to_watchlist, click_category: action_report, click_detail: whos_close
 */
export const whosCloseAddToWatchlistTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.WHOS_CLOSE_AR,
    "add_to_watchlist",
  );
};

/**
 * Tracks removing an ABO from the watchlist.
 * click_action: remove_from_watchlist, click_category: action_report, click_detail: whos_close
 */
export const whosCloseRemoveFromWatchlistTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.WHOS_CLOSE_AR,
    "remove_from_watchlist",
  );
};
